module.exports = __webpack_public_path__ + "img/38-ABITO-SCOSTUMATA-U-ECRU-BIANCO-ECRU-GARZA4.e1939ced.jpg";